export default __webpack_public_path__ + "img/ebtgSvmo.2c35d615.svg";